// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f4f4f9;
}

header {
  background-color: #282c34;
  color: white;
  padding: 20px;
  text-align: center;
}

nav a {
  margin: 0 15px;
  color: white;
  text-decoration: none;
}


#about {
  padding: 50px 20px;
  text-align: center;
}

.profile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-picture {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ddd;
}

.profile-details {
  margin-top: 20px;
}

.profile-details h2 {
  font-size: 1.8em;
  margin: 0;
}

.tag {
  font-size: 0.8em;
  color: #888;
  margin-left: 10px;
}

.profile-details h3 {
  font-size: 1.2em;
  color: #666;
  margin-top: 5px;
}

.description {
  font-size: 1em;
  margin: 15px 0;
  max-width: 500px;
  color: #444;
}

.profile-actions {
  display: flex;
  gap: 10px;
}

.btn {
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
  border: none;
}

.follow-btn {
  background-color: #0095f6;
  color: white;
}

.message-btn {
  background-color: #efefef;
  color: #333;
}

.email-btn {
  background-color: #efefef;
  color: #333;
}

.btn:hover {
  opacity: 0.8;
}


.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 300px); 
  grid-gap: 10px;
  justify-content: center;
  padding: 20px;
}

.project-card {
  position: relative;
  width: 300px;
  height: 300px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-card:hover .overlay {
  opacity: 1;
}

.project-info {
  color: white;
  text-align: center;
}

h3 {
  margin: 0;
}

p {
  margin-top: 10px;
  font-size: 0.9em;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,uCAAuC;EACvC,cAAc;EACd,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n  margin: 0;\n  padding: 0;\n  background-color: #f4f4f9;\n}\n\nheader {\n  background-color: #282c34;\n  color: white;\n  padding: 20px;\n  text-align: center;\n}\n\nnav a {\n  margin: 0 15px;\n  color: white;\n  text-decoration: none;\n}\n\n\n#about {\n  padding: 50px 20px;\n  text-align: center;\n}\n\n.profile-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.profile-picture {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #ddd;\n}\n\n.profile-details {\n  margin-top: 20px;\n}\n\n.profile-details h2 {\n  font-size: 1.8em;\n  margin: 0;\n}\n\n.tag {\n  font-size: 0.8em;\n  color: #888;\n  margin-left: 10px;\n}\n\n.profile-details h3 {\n  font-size: 1.2em;\n  color: #666;\n  margin-top: 5px;\n}\n\n.description {\n  font-size: 1em;\n  margin: 15px 0;\n  max-width: 500px;\n  color: #444;\n}\n\n.profile-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn {\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-size: 1em;\n  cursor: pointer;\n  border: none;\n}\n\n.follow-btn {\n  background-color: #0095f6;\n  color: white;\n}\n\n.message-btn {\n  background-color: #efefef;\n  color: #333;\n}\n\n.email-btn {\n  background-color: #efefef;\n  color: #333;\n}\n\n.btn:hover {\n  opacity: 0.8;\n}\n\n\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(3, 300px); \n  grid-gap: 10px;\n  justify-content: center;\n  padding: 20px;\n}\n\n.project-card {\n  position: relative;\n  width: 300px;\n  height: 300px;\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.project-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.project-card:hover .overlay {\n  opacity: 1;\n}\n\n.project-info {\n  color: white;\n  text-align: center;\n}\n\nh3 {\n  margin: 0;\n}\n\np {\n  margin-top: 10px;\n  font-size: 0.9em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
